/* eslint-disable @repo/internal/deprecations/deprecation-ticket-required -- VOLTC-139 tracks removal of these deprecated re-export shims. */
/**
 * @deprecated Import from the generated per-export subpath instead.
 */

export { fromLegacyPlacement } from '../placement-map/from-legacy-placement';
/**
 * @deprecated Import from the generated per-export subpath instead.
 */
export { LEGACY_PLACEMENTS, type TLegacyPlacement } from '../placement-map/legacy-placements';
/**
 * @deprecated Import from the generated per-export subpath instead.
 */
export type { TPlacementOptions } from '../internal/resolve-placement';
